import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIUsers {
    //This method returns all of an organization's users.
    getAllUsers() {
        return fetchJSON("/users");
    }
    //This request creates a new user profile and sends a profile activation email to their email.
    registerNewUser(params) {
        return fetchJSON("/users", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This request retrieves a single user's data.
    getSpecificUser(userEmail) {
        return fetchJSON(`/users/${userEmail}`);
    }
    // This method can be used to save persistent user settings that are relevant to the application.
    // Settings must be a dictionary of key-value pairs.
    updateSpecificUserSettings(userEmail, params) {
        return fetchJSON(`/users/${userEmail}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes a user profile.
    deleteUser(userEmail) {
        return fetchWithAuth(`/users/${userEmail}`, {
            method: "DELETE",
        });
    }
    //This method uploads a profile picture for a user.
    uploadProfilePicture(userEmail, imageBase64) {
        return fetchJSON(`/users/${userEmail}/profile_img`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                image: imageBase64,
            }),
        });
    }
    //This method deletes a person's profile image.
    deleteProfilePicture(userEmail) {
        return fetchWithAuth(`/users/${userEmail}/profile_img`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-users.js.map